<template>
	<div class="page with-logo">
		<div class="logo"></div>
		<h1>Changed your mind?</h1>
		<p>
			We're all ready to push your show to an audience of gig-goers and live entertainment fans more likely to buy tickets, but we understand if you've changed your mind.
		</p>
		<p>
			If you want to boost something else instead
			<br/>
			<router-link class="start button large gradient sunset" to="/create">Boost it here</router-link>
		</p>
		<p>
			If you have a question for the Boost Buttons team, <a href="mailto:backstage@ents24.com" target="_blank">get in touch</a>.
		</p>
	</div>
</template>

<script>
	export default {
	}
</script>
